var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query';
import { DeviceType } from 'common/types/server-api-dtos';
import { CommonServiceApiTags } from 'common/services/api-tags';
import { fetchNotificationsApi, readNotificationApi } from './api';
import { useNotificationDrawerStore } from './service-store/service-store';
import { checkEqual } from 'common/helpers/checkEqual';
export var useNotificationDrawerData = function (_a) {
    var scrollToTop = _a.scrollToTop;
    var setData = useNotificationDrawerStore(function (state) { return state.setData; });
    var _b = useNotificationDrawerStore(function (state) { return ({
        onlyNotRead: state.onlyNotRead,
        pageSize: state.pageSize,
    }); }, checkEqual), onlyNotRead = _b.onlyNotRead, pageSize = _b.pageSize;
    var _c = useInfiniteQuery({
        queryKey: [CommonServiceApiTags.NotificationDrawer, onlyNotRead],
        staleTime: undefined,
        initialPageParam: 0,
        getNextPageParam: function (lastPage, pages) {
            var totalPages = Math.ceil((lastPage.total || 1) / lastPage.pageData.pageSize);
            return pages.length < totalPages ? pages.length : undefined;
        },
        queryFn: function (_a) {
            var _b = _a.pageParam, pageParam = _b === void 0 ? 0 : _b;
            return __awaiter(void 0, void 0, void 0, function () {
                var data;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, fetchNotificationsApi({
                                deviceType: DeviceType.Web,
                                page: pageParam,
                                onlyNotRead: onlyNotRead,
                                pageSize: pageSize,
                            })];
                        case 1:
                            data = _c.sent();
                            return [2 /*return*/, data];
                    }
                });
            });
        },
    }), data = _c.data, fetchNextPage = _c.fetchNextPage;
    if (data) {
        if (data.pages.length == 1) {
            scrollToTop();
            setData(data.pages);
        }
        else {
            setData(data.pages);
        }
    }
    return fetchNextPage;
};
export var useReadNotifications = function () {
    var setElementRead = useNotificationDrawerStore(function (state) { return state.setElementRead; });
    var queryClient = useQueryClient();
    return function (_a) {
        var pushId = _a.pushId, _b = _a.deviceType, deviceType = _b === void 0 ? DeviceType.Web : _b, isRead = _a.isRead, successCb = _a.successCb;
        return readNotificationApi({ pushId: pushId, deviceType: deviceType, isRead: isRead }).then(function () {
            setElementRead(pushId);
            queryClient.removeQueries({
                queryKey: [CommonServiceApiTags.NotificationDrawer],
            });
            successCb === null || successCb === void 0 ? void 0 : successCb();
        });
    };
};
